import { createFileRoute } from '@tanstack/react-router';
import { VideoPlayerPage } from '../../../../features/community-hub/components/video-player-page';

/**
 * Community Hub - Video Player Route
 * Path: /community-hub/videos/:id
 *
 * Full-page video player for Vimeo content blocks
 */
export const Route = createFileRoute('/_protected/community-hub/videos/$id')({
  component: VideoPlayerPage,
});
